export type SortOptions = {
  by: SortBy
  direction: SortDirection
}

export enum SortBy {
  Area = 'AREA',
  Date = 'DATE',
  Price = 'PRICE',
  Ranking = 'RANKING',
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}
